import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var Cambio_profesionalComponent = /** @class */ (function () {
    function Cambio_profesionalComponent(_formService) {
        this._formService = _formService;
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            cambio_profesional: new FormControl(''),
        });
        if (!JSON.parse(localStorage.getItem("cambio_profesional"))) {
            localStorage.setItem("cambio_profesional", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("cambio_profesional"));
            this.form.controls['cambio_profesional'].setValue(this.rows[0] ? this.rows[0].cambio_profesional : '');
        }
    }
    Cambio_profesionalComponent.prototype.add_cambio_profesional = function () {
        localStorage.setItem("cambio_profesional", JSON.stringify([]));
        this.actualRow = localStorage.getItem("cambio_profesional");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            cambio_profesional: this.form.value.cambio_profesional,
        });
        localStorage.setItem("cambio_profesional", JSON.stringify(this.rows));
        //this.form.reset();
        //this.cip = JSON.parse(localStorage.getItem("cip"));
    };
    Cambio_profesionalComponent.prototype.delete_cambio_profesional = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("cambio_profesional", JSON.stringify(this.rows));
            }
        }
    };
    return Cambio_profesionalComponent;
}());
export { Cambio_profesionalComponent };
